import { toast } from "react-toastify";

import { useEffect } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _AbstractAccount, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { SelectSiteID } from "../../../../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { FiEdit } from "react-icons/fi";
import { FileService } from "../../../../../../../core/services/FileService";

interface PropsBasicData {
    IDAccount?: number
}

export const BasicDataUpdate = ({ IDAccount }: PropsBasicData) => {

    const { instance, setBean, bean } = useDataBean(_AbstractAccount);
    const fileService = new FileService();


    useEffect(() => {
        getAccount()
    }, [])

    const getAccount = () => {
        instance.getAccountbyID(IDAccount ?? _single.getAccountID()).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => { toast.error("No se pudo cargar la información") }
        )
    }

    const updateAccount = () => {
        instance.updateAbstractAccount(bean).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => { toast.error("No se pudo actualizar la información") }
        )
    }

    return (
        <div className="row">
            {/* <div className="col-md-12">
                <div className="image-preview" style={{ textAlign: 'center' }}>
                    <div className="profile_circle">
                        <img className='profile_img' src={bean.Photo ? fileService.getUrlFile("photos", bean.Photo) : null} alt='profile_img' />
                        <span className='icon_edit' title='Cambiar foto'>
                            <FiEdit />
                        </span>
                    </div>
                </div>
            </div> */}
            <div className="col-6">
                <SelectSiteID label='Lugar de Nacimiento' edit onChange={(e) => { setBean({ ...bean, "IDBornSiteLn": e.IDLn }) }} idLnSite={bean.IDBornSiteLn} />
            </div>
            <div className="col-6">
                <SelectSiteID label='Lugar de Residencia' edit onChange={(e) => { setBean({ ...bean, "IDResidenceSiteLn": e.IDLn }) }} idLnSite={bean.IDResidenceSiteLn} />
            </div>
            <div className="col-6">
                <label>Dirección</label>
                <input type="text" className='form-control' name='Address' value={bean.Address} onChange={(e) => { setBean({ ...bean, Address: e.target.value }) }} />
            </div>
            <div className="col-6">
                <label>Telefono</label>
                <input type="text" className='form-control' name='Tel' value={bean.Tel} onChange={(e) => { setBean({ ...bean, Tel: e.target.value }) }} />
            </div>

            <div className="col-md-12 mt-2">
                <BasicButton eventClick={updateAccount} icon="ri-save-line" children={`Guardar Información`} />
            </div>
        </div>
    )
}